var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-page-transition',{attrs:{"name":"fade-in-down"}},[_c('v-content',{staticClass:"db-content"},[_c('v-card',{staticStyle:{"top":"-60px"},attrs:{"flat":""}},[_c('ResearchNotes')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }